import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {
    ThinCaretDownIcon,
    ThinClassIcon,
    ThinInfoIcon,
    ThinTimeIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {SelectClassModal} from "../classes/select-class-modal";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {AdminTuitionPaymentInfoModal} from "../students/payment-info-modal";
import {tuitionPaymentInterface} from "./tuition-payments";

export const AdminsFinanceTuitionPaymentsOnlineScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [list, setList] = useState([] as tuitionPaymentInterface[]);
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const fetchList = (classId: number, classTitle: string) => {
        setFilters({shown: ''});
        const t = {...time};
        console.log(t);
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        setLoaded(false);
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/finance/tuition-payments/list",
            {
                from: fromString,
                to: toString,
                classId: classId.toString(),
                type: 'online',
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: tuitionPaymentInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرداخت‌های آنلاین شهریه | نهال";
        fetchList(0, '');
    }, []);
    const [paymentInfo, setPaymentInfo] = useState({
        show: false,
        id: 0,
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'پرداخت‌های آنلاین شهریه', url: '/admins/finance/tuition/online'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>پرداخت‌های شهریه آنلاین</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    {/*<button onClick={() => {*/}
                                    {/*    const _class = {...classSelected};*/}
                                    {/*    const now = {...time};*/}
                                    {/*    const from = PersianToGregorian(DateFixToGoLayout(`${now.from?.year}-${now.from?.month}-${now.from?.day}`));*/}
                                    {/*    const to = PersianToGregorian(DateFixToGoLayout(`${now.to?.year}-${now.to?.month}-${now.to?.day}`));*/}
                                    {/*    window.open(`/print/admins/finance/tuition/${from}/${to}/${_class.id}`);*/}
                                    {/*}}>*/}
                                    {/*    <ThinPrintIcon/>*/}
                                    {/*    <span>پرینت</span>*/}
                                    {/*</button>*/}
                                    <button onClick={() => setClassModal(true)}>
                                        <ThinClassIcon/>
                                        <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                    </button>
                                    <div className="filter-buttons">
                                        <ClickOutsideDetector
                                            onClickOutside={() => {
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = '';
                                                    return x;
                                                });
                                            }}
                                            className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                            <button onClick={(e) => {
                                                e.stopPropagation();
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = x.shown === 'time' ? '' : 'time';
                                                    return x;
                                                });
                                            }}>
                                                <ThinTimeIcon/>
                                                <span>زمان</span>
                                                <ThinCaretDownIcon/>
                                            </button>
                                            {
                                                filters.shown === 'time' ?
                                                    <div>
                                                        <label className="f-roboto">لطفا یک بازه
                                                            زمانی را انتخاب
                                                            کنید:</label>
                                                        <Calendar
                                                            value={time}
                                                            onChange={e => setTime(e)}
                                                            shouldHighlightWeekends
                                                            colorPrimary='#0a53be'
                                                            locale={'fa'}
                                                        />
                                                        <div className="text-end">
                                                            <button
                                                                className="filter-button-cta"
                                                                onClick={() => fetchList(classSelected.id, classSelected.title)}>
                                                                <span>اعمال تغییرات</span>
                                                            </button>
                                                        </div>
                                                    </div> :
                                                    null
                                            }
                                        </ClickOutsideDetector>
                                    </div>
                                </div>
                            </div>
                            <table className="table open-table table-striped table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>دانش‌آموز</th>
                                    <th>کدملی</th>
                                    <th>مبلغ</th>
                                    <th>کد رهگیری</th>
                                    <th>تاریخ</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((p, i) =>
                                        <tr key={"K39ErcnS" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/students/view/${p.studentId}`}>
                                                    {p.studentName}
                                                </Link>
                                            </td>
                                            <td>{StringDigitsConvertToPersian(p.nationalCode)}</td>
                                            <td>
                                                <span>{CurrencyFormat(p.price)}<TomansIcon/></span>
                                            </td>
                                            <td>{p.traceNo !== '' ? StringDigitsConvertToPersian(p.traceNo) : '-'}</td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(p.paidAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>
                                                {
                                                    p.payMethod === "online" ?
                                                        <button onClick={() => setPaymentInfo({
                                                            show: true,
                                                            id: p.id,
                                                        })} className="open-tooltip">
                                                            <ThinInfoIcon/>
                                                            <i>اطلاعات پرداخت</i>
                                                        </button>
                                                        : '-'
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchList(id, title);
                }}
            />
            <AdminTuitionPaymentInfoModal
                active={paymentInfo.show}
                closeHandler={() => setPaymentInfo(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                paymentId={paymentInfo.id}
            />
        </>
    );
};